import React, { useState, useEffect, createContext, useContext } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import axios from 'axios';
import { Calendar, FileText, Settings, Building2 } from 'lucide-react';
import { API_BASE_URL } from './config';
import VacationFormPage from './pages/VacationFormPage/VacationFormPage';
import VacationCalendarPage from './pages/VacationCalendarPage/VacationCalendarPage';
import AdminPage from './pages/AdminPage/AdminPage';
import './App.css';

const DepartmentContext = createContext();

export const useDepartment = () => useContext(DepartmentContext);

function App() {
    const location = useLocation();
    const [selectedDepartment, setSelectedDepartment] = useState(() => {
        return localStorage.getItem('selectedDepartment') || '';
    });

    const { data: departments } = useQuery('departments', async () => {
        const response = await axios.get(`${API_BASE_URL}/departments`);
        return response.data;
    });

    useEffect(() => {
        if (departments?.length > 0 && !selectedDepartment) {
            const firstDep = departments[0].name;
            setSelectedDepartment(firstDep);
            localStorage.setItem('selectedDepartment', firstDep);
        }
    }, [departments, selectedDepartment]);

    const handleDepartmentChange = (value) => {
        setSelectedDepartment(value);
        localStorage.setItem('selectedDepartment', value);
    };

    return (
        <DepartmentContext.Provider value={{ selectedDepartment, setSelectedDepartment, departments }}>
            <div className="app">
                <header className="header">
                    <div className="header-content">
                        <Link to="/" className="logo">
                            <Calendar size={28} />
                            <span>Отпуска</span>
                        </Link>
                        
                        <div className="department-selector">
                            <Building2 size={18} />
                            <select 
                                value={selectedDepartment} 
                                onChange={(e) => handleDepartmentChange(e.target.value)}
                            >
                                {departments?.map(dep => (
                                    <option key={dep.id} value={dep.name}>{dep.name}</option>
                                ))}
                            </select>
                        </div>

                        <nav className="nav">
                            <Link
                                to="/"
                                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                            >
                                <FileText size={18} />
                                Заявка
                            </Link>
                            <Link
                                to="/calendar"
                                className={`nav-link ${location.pathname === '/calendar' ? 'active' : ''}`}
                            >
                                <Calendar size={18} />
                                Календарь
                            </Link>
                            <Link
                                to="/admin"
                                className={`nav-link ${location.pathname === '/admin' ? 'active' : ''}`}
                            >
                                <Settings size={18} />
                                Админ
                            </Link>
                        </nav>
                    </div>
                </header>
                <main className="main">
                    <Routes>
                        <Route path="/" element={<VacationFormPage />} />
                        <Route path="/calendar" element={<VacationCalendarPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                    </Routes>
                </main>
            </div>
        </DepartmentContext.Provider>
    );
}

export default App;
